import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import PageHero from "../components/global/PageHero";
import LegalBody from "../components/legal/LegalBody";

export default function PrivacyPolicy() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Legal" title="Privacy Policy">
                    We're committed to protecting the personal information you share with us when you use our website. This page explains what we collect and how we use it.
                </PageHero>

                <LegalBody />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
